import { emptyMapStateToProps } from 'reg_redesign/redux/connectFunctions';
import ProgressBar from 'reg_redesign/ProgressBar';

const { merge } = require('lodash');

const progressBarConfig = {
  component: ProgressBar,
  stateToPropsOverride: emptyMapStateToProps
};

function configureProgressBar(value) {
  return merge({}, progressBarConfig, {
    props: { value, key: `progress-bar${value}` }
  });
}

export default configureProgressBar;
